import React from 'react'
import ClaimSectionBreadcrumb from './ClaimSectionBreadcrumb'
import SubmitClaimWithIdentificationNumber from './SubmitClaimWithIdentificationNumber'
import SubmitClaimFailed from './SubmitClaimFailed'
import SubmitClaimSuccess from './SubmitClaimSuccess'

class SubmitClaim extends React.Component {
  constructor(props) {
    super(props)

    this.sectionGroups = props.section_groups.concat(['Review and Submit', 'Request Submitted'])
    this.state = {
      redirectButton: null
    }
  }

  renderSubmitClaim () {
    if (this.props.status == 'completed' && this.props.workflow_unum) {
      return (
        <SubmitClaimWithIdentificationNumber
          { ...this.props }
          redirectButton={ this.redirectButton.bind(this) }
          unumTheme={ this.checkUnumLayout.bind(this) }
        />
      )
    } else if (this.props.status == 'failed') {
      return (
        <SubmitClaimFailed
          {...this.props}
          redirectButton={ this.redirectButton.bind(this) }
        />
      )
    } else {
      return (
        <SubmitClaimSuccess
          {...this.props}
          redirectButton={ this.redirectButton.bind(this) }
          unumTheme={ this.checkUnumLayout.bind(this) }
        />
      )
    }
  }

  checkUnumLayout () {
    return gon.employee_layout == 'unum_theme'
  }

  redirectButton() {
    return (this.checkUnumLayout() ?
      <a href='/app/claims' className='btn btn-dark btn-bdr-rds'>Back to my Claims</a> : 
      <a href='/claims'className='btn btn-dark btn-bdr-rds'>Back to my Claims</a>
    )
  }
  renderSection(index, sectionGroupName) {
    let completedClass = 'completed'
    let activeClass = ''
    if (this.props.status == 'submitted' && sectionGroupName == 'Request Submitted') {
      completedClass = ''
      activeClass = 'active'
    }
    return (
      <ClaimSectionBreadcrumb
        sectionGroupName={sectionGroupName}
        completedClass={completedClass}
        activeClass={activeClass}
        index={index}
        key={index}
      />
    )
  }

  render () {
    return (
      <div>
        <div className='header-div'>
          <h3 className='claim-submission-header'>
            Prepare your Claim
          </h3>
          <span>
            {`In only few steps, you can file your claim with ${this.props.request_recipient} right from LeaveLogic. Please review and update the following information to submit your claim and start your eligibility determination`}
          </span>
        </div>
        <div className='claim-information-div'>
          <div className='image-div'>
            <div className='claim-image' style={{ backgroundImage: `url(${this.props.logo_url})` }} />
          </div>
          <div className='claim-name'>
            { this.props.name }
          </div>
        </div>
        <div className='claim-sections-breadcrumb'>
          {
            this.sectionGroups.map((sectionGroupName, index) => this.renderSection(index, sectionGroupName,))
          }
        </div>
        {this.renderSubmitClaim()}
      </div>
    )
  }
}

export default SubmitClaim;